import { useEffect } from 'react';
import type { Asset } from '@schibsted-svp/svp-api-types';
import { useHistoryPreview as useHistoryPreviewState } from 'components/core/History';
import { useLazyAssetHistoryQuery } from 'services/admin-bff-sdk/generated';
import { prepareHistoryData, type HistoryData } from './helpers';

export function useGetAssetHistoryData(asset: Asset, isExpanded: boolean) {
    const [getAssetHistory, { data, isLoading, isError }] = useLazyAssetHistoryQuery();

    useEffect(() => {
        if (isExpanded) {
            getAssetHistory({ newsroom: asset.provider, assetId: asset.id });
        }
    }, [isExpanded, asset.provider, asset.id, asset.updated, getAssetHistory]);

    const historyData = prepareHistoryData(data?.assetHistory as Asset[]);

    return { historyData, isLoading, isError };
}

export function useHistoryPreview() {
    return useHistoryPreviewState<HistoryData>();
}
